
















import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import Node from '../../../models/Node';
import { LMarker } from 'vue2-leaflet';

@Component({
	refs: ['marker'],
	watch: {
		title(){
			let tg = this as CVMarker;
			let marker = this.$refs.marker as LMarker;
			marker.mapObject.unbindTooltip();
			tg.generateTooltip(marker);
		}
	}
})
export default class CVMarker extends Vue {
	@Prop() readonly marker! : {position: [], node: Node};
	@Prop(String) readonly title! : string;
	mounted(){
		this.$nextTick(()=>{
			let marker = this.$refs.marker as LMarker;
			this.generateTooltip(marker);
		})
	}

	generateTooltip(marker : LMarker){
		marker.mapObject.bindTooltip(this.title, {
			permanent: true,
			direction: 'top'
		});
	}
}
